<template>
  <div class="cartoon-main">
    <div
      v-for="(item, index) in list"
      :key="index"
      class="cartoon-content"
      @click="goDetail(item.uuid, 'type')"
    >
      <van-image class="video-img" :src="item.thumb_img">
        <template v-slot:loading>
          <van-image
            width="127"
            height="82"
            class=""
            :src="require('@/assets/default.png')"
          />
        </template>
        <template v-slot:error
          ><van-image
            width="127"
            height="82"
            class=""
            :src="require('@/assets/default.png')"
        /></template>
      </van-image>
      <div class="title-main">
        <div class="title" v-html="item.title"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    list: {
      type: Array,
    },
  },
  data() {
    return {};
  },
  methods: {
    goDetail(id) {
      this.$router.push({
        path: "/wallchart/" + id,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.cartoon-main {
  min-height: calc(100vh - 700px);
}

.cartoon-content {
  position: relative;
  display: inline-block;
  width: 330px;
  height: 562px;
  margin-top: 30px;
  margin-left: 30px;
  cursor: pointer;

  .title-main {
    position: relative;
    top: -10px;
    width: 100%;
    height: 100px;
    background: #fff;
    box-shadow: 0 0 9px 0 rgba(163, 162, 162, 27%); /* stylelint-disable-line */

    .title {
      display: -webkit-box; /* stylelint-disable-line */
      display: -ms-flexbox; /* stylelint-disable-line */
      width: 295px;
      height: 100px;
      margin-top: 0;
      margin-left: 22px;
      overflow: hidden;
      font-size: 28px;
      font-weight: 400;
      line-height: 50px;
      color: #000;
      text-overflow: ellipsis;
      word-break: break-all;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      ::v-deep span {
        color: rgb(0 71 255 / 100%);
      }
    }
  }

  .video-img {
    width: 330px;
    height: 462px;
  }
}

// .cartoon-content + .cartoon-content {
//   margin-left: 60px;
// }
</style>
